module.exports = __webpack_public_path__ + "static/media/user-marker.8bc261fb.svg";